import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import { Menu, X } from 'lucide-react';
import { TopRibbon } from './TopRibbon';
export function Navbar() {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();
  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    name: 'Home',
    path: '/'
  }, {
    name: 'About',
    path: '/about'
  }, {
    name: 'Services',
    path: '/services'
  }, {
    name: 'Programs',
    path: '/programs'
  }, {
    name: 'Blog',
    path: '/blog'
  }, {
    name: 'Contact',
    path: '/contact'
  }];
  return <header className="fixed top-0 left-0 right-0 z-50" data-id="element-55">
      <TopRibbon data-id="element-56" />
      <nav className={`transition-all duration-300 ${scrolled ? 'bg-white shadow-lg py-1' : 'bg-white/90 backdrop-blur-md py-1'}`} role="navigation" aria-label="Main navigation" data-id="element-57">
        <div className="max-w-7xl mx-auto px-6 flex items-center justify-between" data-id="element-58">
          <Link to="/" className="flex items-center gap-3 shrink-0" aria-label="Global Restorative Home" data-id="element-59">
            <img src="https://cdn.magicpatterns.com/uploads/5kYZM3bXgFrv2MfbGGG85T/Global_Restorative3_(1).jpg" alt="Global Restorative Logo" className="h-14 md:h-[67px] w-auto object-contain" data-id="element-60" />
          </Link>

          {/* Desktop Menu */}
          <div className="hidden lg:flex items-center gap-6" data-id="element-61">
            {navLinks.map(link => <Link key={link.path} to={link.path} className={`font-display text-[11px] uppercase tracking-[0.15em] transition-colors hover:text-medical-red ${location.pathname === link.path ? 'text-medical-red font-bold' : 'text-medical-blue/80 font-semibold'}`} data-id="element-62">
                {link.name}
              </Link>)}
          </div>

          <div className="hidden lg:block" data-id="element-63">
            <Link to="/contact" className="bg-medical-red text-white px-6 py-2.5 rounded-full font-display text-[10px] uppercase tracking-[0.15em] font-bold hover:bg-medical-blue transition-all shadow-md" data-id="element-64">
              Book Consultation
            </Link>
          </div>

          {/* Mobile Toggle */}
          <button className="lg:hidden p-2 text-medical-blue" onClick={() => setIsOpen(!isOpen)} aria-expanded={isOpen} aria-label="Toggle menu" data-id="element-65">
            {isOpen ? <X size={28} data-id="element-66" /> : <Menu size={28} data-id="element-67" />}
          </button>
        </div>

        {/* Mobile Menu */}
        <AnimatePresence data-id="element-68">
          {isOpen && <motion.div initial={{
          opacity: 0,
          height: 0
        }} animate={{
          opacity: 1,
          height: 'auto'
        }} exit={{
          opacity: 0,
          height: 0
        }} className="lg:hidden bg-white border-t border-medical-gray overflow-hidden" data-id="element-69">
              <div className="px-6 py-8 flex flex-col gap-6" data-id="element-70">
                {navLinks.map(link => <Link key={link.path} to={link.path} onClick={() => setIsOpen(false)} className="font-heading text-lg font-bold text-medical-blue" data-id="element-71">
                    {link.name}
                  </Link>)}
                <Link to="/contact" onClick={() => setIsOpen(false)} className="bg-medical-red text-white px-6 py-4 rounded-xl text-center font-heading font-bold" data-id="element-72">
                  Book Consultation
                </Link>
              </div>
            </motion.div>}
        </AnimatePresence>
      </nav>
    </header>;
}